// Module
var code = "<div class=\"unsubscribe-button legaldoc\"><div class=\"btn btn-danger\" ng-if=\"!vm.unsubscribed\" ng-click=\"vm.unsubscribe()\" loading-when=\"vm.unsubscribing\">Unsubscribe</div><span ng-if=\"vm.unsubscribed\">Unsubscribed</span></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/visits/list/tabs/rx-hub/components/unsubscribe-legaldoc/unsubscribe-legaldoc-button.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;